export default __webpack_public_path__ + "static/media/experience.da925ce5.png";